export const DARK_GRAY = '#344153'
export const VERY_LIGHT_GRAY = '#D4DADD'

export const VERY_LIGHT_BACKGROUND_GRAY = '#F6F8FA'

export const DARK_GRAY_CONTENT = '#585F6A'
